import React from "react";
import { Form, Row, Col, InputGroup } from "react-bootstrap";

interface StartDateSectionProps {
  value: string;
  onChange: (date: string) => void;
  paymentAmount: string;
  onPaymentAmountChange: (v: string) => void;
  disabled?: boolean;
  sectionNumber?: number;
}

const StartDateSection: React.FC<StartDateSectionProps> = ({
  value,
  onChange,
  paymentAmount,
  onPaymentAmountChange,
  disabled,
  sectionNumber = 9,
}) => {
  return (
    <div className="enrolment-form-section">
      <h6 className="enrolment-section-title">
        <span className="enrolment-section-number">{sectionNumber}</span>
        Start Date &amp; Payment
      </h6>

      <Row className="g-3">
        <Col xs={12} md={4}>
          <Form.Label className="mb-1 text-muted" style={{ fontSize: 12 }}>
            Enrolment Start Date *
          </Form.Label>
          <Form.Control
            type="date"
            value={value}
            onChange={(e) => onChange(e.target.value)}
            readOnly={disabled}
            disabled={disabled}
          />
        </Col>

        <Col xs={12} md={4}>
          <Form.Label className="mb-1 text-muted" style={{ fontSize: 12 }}>
            Payment Amount (₹) {!disabled && "*"}
          </Form.Label>
          <InputGroup>
            <InputGroup.Text>₹</InputGroup.Text>
            <Form.Control
              type="number"
              placeholder="0"
              min={1}
              value={paymentAmount}
              readOnly={disabled}
              onChange={(e) => !disabled && onPaymentAmountChange(e.target.value)}
            />
          </InputGroup>
        </Col>
      </Row>
    </div>
  );
};

export default StartDateSection;
